export default "__VITE_ASSET__CNaiuXrF__"